import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { a as RadioGroupProvider } from './RadioGroupContext-CZtwmSGz.js';
import { R as RadioButtonGroup } from './RadioButtonGroup/RadioButtonGroup-9faRFQzJ.js';

const RadioGroup = ({
  children,
  disabled = false,
  hideLabel = false,
  inlineLabel = false,
  inline = false,
  name,
  label,
  onChange,
  // removing this, it's handled by bubbled children events
  selectedValue,
  ...rest
}) => {
  const handleRadioChange = event => {
    const {
      value
    } = event.target;
    if (onChange && value !== selectedValue) {
      onChange(value, event);
    }
  };
  return /*#__PURE__*/React__default.createElement(RadioGroupProvider, {
    handleRadioChange: handleRadioChange,
    isGroupInline: inline,
    isGroupDisabled: disabled,
    name: name,
    selectedValue: selectedValue
  }, /*#__PURE__*/React__default.createElement(RadioButtonGroup, _extends({}, rest, {
    inline: inline,
    inlineLabel: inlineLabel,
    label: label,
    disabled: disabled,
    hideLabel: hideLabel
  }), children));
};

export { RadioGroup as R };
//# sourceMappingURL=RadioGroup-C9o13cZ_.js.map
